/* eslint-disable jsx-a11y/anchor-is-valid */
import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider, useQueryRequest} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {
  getSavedFilter,
  getSavedPagination,
  initialQueryState,
  KTCard,
  KTSVG,
  QUERIES,
} from '../../../../../_metronic/helpers'
import {ReceiversTable} from './table/ReceiversTable'
import {ReceiversListHeader} from './components/header/ReceiversListHeader'
import {AddReceiverModal} from './add-receiver-modal/AddReceiverModal'
import {FormattedMessage} from 'react-intl'
import {useEffect} from 'react'
import {ReceiversListFilter} from './components/header/ReceiversListFilter'

const ReceiversList = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const openAddReceiverModal = () => {
    setItemIdForUpdate(null)
  }
  const {updateState} = useQueryRequest()

  useEffect(() => {
    const retrievedData = getSavedPagination()
    const savedFilter = getSavedFilter(QUERIES.FULF_RECEIVERS_LIST)

    const state = {
      ...initialQueryState,
      itemsPerPage: retrievedData,
    }

    if (savedFilter) {
      state.filter = savedFilter
    }

    updateState(state)
  }, [])

  return (
    <>
      <div
        style={{marginTop: '-4%', zIndex: '60'}}
        className='d-flex justify-content-end align-items-center mb-8 position-relative'
      >
        <ReceiversListFilter />
        <button type='button' className='btn btn-sm btn-primary' onClick={openAddReceiverModal}>
          <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
          <FormattedMessage id='RECEIVERS.PAGE.LIST.ADD_BUTTON' />
        </button>
      </div>
      <KTCard>
        <ReceiversListHeader />
        <ReceiversTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <AddReceiverModal />}
    </>
  )
}

const ReceiversListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ReceiversList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {ReceiversListWrapper}
